import { UserType } from '@bulthaup/api/db';
import { Select } from '@mantine/core';
import { useLocation, useParams } from '@tanstack/react-router';

import { useUser } from '../../../../hooks/use-user';
import { trpc } from '../../../../services/trpc';

export function ProjectSiblingsSelector({
  customerId,
}: {
  customerId: string;
}) {
  const { data: projects } = trpc.projects.listCustomerProjects.useQuery({
    customerId,
  });
  const { user } = useUser();

  // Get the current project slug from URL
  const { slug } = useParams({ from: '/app/projets/$slug' });
  const location = useLocation();

  // Extract current tab from pathname (e.g., /app/projets/slug/facturation -> facturation)
  const currentTab = location.pathname.split('/').pop() || 'accueil';

  if (!projects || projects.length <= 1 || user.type === UserType.INSTALLER) {
    return null;
  }

  return (
    <Select
      //   label="Autres projets du client"
      placeholder="Sélectionner un projet"
      data={projects.map(project => ({
        value: project.slug,
        label: project.name,
        disabled: project.slug === slug,
      }))}
      onChange={value => {
        if (value) {
          window.location.href = `/app/projets/${value}/${currentTab}`;
        }
      }}
      value={slug}
    />
  );
}
